// extracted by mini-css-extract-plugin
export default {"dialogDescriptionWrap":"style_dialogDescriptionWrap__UY1eY","modalWrap":"style_modalWrap__Fmhmm"};